// Hook to detect if we should use mobile (iPhone) layout
// Returns true for screens < 640px (Tailwind's 'sm' breakpoint)

import { useState, useEffect } from 'react'

const MOBILE_BREAKPOINT = 640

export function useMobileLayout() {
  const [isMobile, setIsMobile] = useState(() => {
    // Initial check (SSR-safe)
    if (typeof window === 'undefined') return false
    return window.innerWidth < MOBILE_BREAKPOINT
  })

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }

    // Check on mount
    checkMobile()

    // Listen for resize
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return isMobile
}

export default useMobileLayout
